module.exports = __webpack_public_path__ + "static/media/picto_type_milling.37200d7a.svg";